/* !!! This file is auto-generated. Please edit the source files instead */
(() => {
  var __defProp = Object.defineProperty;
  var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // src/js/sections/announcement.js
  var announcementBar = /* @__PURE__ */ function() {
    function init() {
      const announcementSlider = document.querySelector(".announcement__slider");
      const buttons = document.querySelectorAll(".announcement__text .custom-select__btn");
      if (!announcementSlider || buttons.length === 0) return;
      buttons.forEach((button) => {
        button.addEventListener("mousedown", function() {
          announcementSlider.style.overflowX = "visible";
        });
      });
      document.addEventListener("mousedown", (e) => {
        const btn = e.target.closest(".custom-select__btn");
        if (btn) return;
        const allButtons = document.querySelectorAll(".custom-select__btn");
        let clickedInsideListbox = false;
        allButtons.forEach((button) => {
          const listbox = button.nextElementSibling;
          if (listbox && listbox.classList.contains("custom-select__listbox")) {
            if (listbox.contains(e.target)) {
              clickedInsideListbox = true;
            }
          }
        });
        if (!clickedInsideListbox) {
          announcementSlider.style.overflowX = "scroll";
        }
      });
    }
    __name(init, "init");
    return {
      init
    };
  }();
  var announcement_default = announcementBar;

  // src/js/sections/main-product.js
  var mainProduct = /* @__PURE__ */ function() {
    function init() {
      handleProductConsent();
      addVariantToCart();
      hideEmptyDisclosures();
      handlePromoPriceAndLabel();
    }
    __name(init, "init");
    function handleProductConsent() {
      const productConsentEl = document.querySelector(".product-consent");
      const productConsentInput = productConsentEl == null ? void 0 : productConsentEl.querySelector("#product_consent");
      const addToCartBtn = document.querySelector('button[type="submit"]');
      if (!productConsentEl || !productConsentInput || !addToCartBtn) return;
      productConsentInput.addEventListener("change", (e) => {
        if (e.currentTarget.checked) {
          addToCartBtn.classList.remove("disabled");
        } else {
          addToCartBtn.classList.add("disabled");
        }
      });
    }
    __name(handleProductConsent, "handleProductConsent");
    function addVariantToCart() {
      const atcButtons = document.querySelectorAll(".additional-product__atc");
      if (atcButtons.length === 0) return;
      atcButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const variantID = button.dataset.variantId;
          if (!variantID) return;
          const formData = {
            items: [
              {
                id: Number(variantID),
                quantity: 1
              }
            ]
          };
          const cartDrawer = document.querySelector("cart-drawer");
          let sections = "cart-icon-bubble";
          if (cartDrawer) {
            const cartSection = cartDrawer.closest(".shopify-section");
            if (cartSection && cartSection.id.startsWith("shopify-section-")) {
              const sectionId = cartSection.id.replace("shopify-section-", "");
              sections += `,${sectionId}`;
            }
          }
          formData.sections = sections;
          fetch(`${theme.routes.cartAdd}.js`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: {
              "Content-Type": "application/json"
            }
          }).then((response) => response.json()).then((data) => {
            if (cartDrawer && typeof cartDrawer.renderContents === "function") {
              setTimeout(() => {
                cartDrawer.renderContents(data, true);
              }, 700);
              document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
            }
          }).catch((error) => {
            console.error("Error adding to cart:", error);
          });
        });
      });
    }
    __name(addVariantToCart, "addVariantToCart");
    function hideEmptyDisclosures() {
      const disclosures = document.querySelectorAll("details-disclosure");
      if (disclosures.length === 0) return;
      disclosures.forEach((el) => {
        const content = el.querySelector(".disclosure__content");
        if (content && content.textContent.trim() === "") {
          el.style.display = "none";
        }
      });
    }
    __name(hideEmptyDisclosures, "hideEmptyDisclosures");
    function handlePromoPriceAndLabel() {
      const realPriceEl = document.querySelector(".product-info__price--real");
      const promoPriceEl = document.querySelector(".product-info__price--fake");
      const extraInfoEl = document.querySelector(".product-info__extra-information");
      if (!realPriceEl || !promoPriceEl || !extraInfoEl) return;
      const currentPriceEl = promoPriceEl.querySelector(".price__current-value");
      const wasPriceEl = promoPriceEl.querySelector(".price__was-value");
      const moneyFormat = /* @__PURE__ */ __name((cents) => {
        var _a, _b;
        const value = Math.round(Number(cents) || 0);
        const currency = ((_b = (_a = window == null ? void 0 : window.ShopifyAnalytics) == null ? void 0 : _a.meta) == null ? void 0 : _b.currency) || "EUR";
        const locale = document.documentElement.lang || "en";
        return new Intl.NumberFormat(locale, { style: "currency", currency }).format(value / 100);
      }, "moneyFormat");
      const parsePromotionData = /* @__PURE__ */ __name((raw) => {
        if (!raw) return null;
        if (typeof raw === "string") {
          const trimmed = raw.trim();
          if (trimmed.startsWith("<script")) {
            const wrapper = document.createElement("div");
            wrapper.innerHTML = trimmed;
            const scriptEl = wrapper.querySelector("script.metafield-json");
            if (scriptEl && scriptEl.textContent) {
              try {
                return JSON.parse(scriptEl.textContent);
              } catch (e) {
                return null;
              }
            }
            return null;
          }
          try {
            return JSON.parse(trimmed);
          } catch (e) {
            return null;
          }
        }
        if (typeof raw === "object") return raw;
        return null;
      }, "parsePromotionData");
      const getVariantWithMetafields = /* @__PURE__ */ __name((selectedVariant, allVariants) => {
        return Array.isArray(allVariants) ? allVariants.find((v) => String(v.id) === String(selectedVariant.id)) : null;
      }, "getVariantWithMetafields");
      const getActiveCampaign = /* @__PURE__ */ __name((promotionData) => {
        if (!promotionData) return null;
        const now = Date.now();
        const isActive = /* @__PURE__ */ __name((promo) => {
          if (!promo.price_now || !promo.start_date || !promo.end_date) return false;
          const start = new Date(promo.start_date).getTime();
          const end = new Date(promo.end_date).getTime();
          return now >= start && now < end;
        }, "isActive");
        if (promotionData.price_now) {
          return isActive(promotionData) ? promotionData : null;
        }
        if (Array.isArray(promotionData)) {
          let best = null;
          promotionData.forEach((promo) => {
            if (isActive(promo)) {
              if (!best || parseFloat(promo.price_now) < parseFloat(best.price_now)) {
                best = promo;
              }
            }
          });
          return best;
        }
        return null;
      }, "getActiveCampaign");
      const updatePriceDisplay = /* @__PURE__ */ __name((selectedVariant, allVariants) => {
        var _a, _b;
        const variantWithMetafields = getVariantWithMetafields(selectedVariant, allVariants);
        const promotionRaw = ((_b = (_a = variantWithMetafields == null ? void 0 : variantWithMetafields.metafields) == null ? void 0 : _a.custom) == null ? void 0 : _b.promotion_campaign) || null;
        const promotionData = parsePromotionData(promotionRaw);
        const activeCampaign = getActiveCampaign(promotionData);
        if (activeCampaign) {
          const discountedCents = Math.round(parseFloat(activeCampaign.price_now) * 100);
          const baseCents = Math.round(selectedVariant.compare_at_price || selectedVariant.price);
          if (currentPriceEl) currentPriceEl.textContent = moneyFormat(discountedCents);
          if (wasPriceEl) wasPriceEl.textContent = moneyFormat(baseCents);
          realPriceEl.classList.add("hidden");
          promoPriceEl.classList.remove("hidden");
          promoPriceEl.classList.add("block");
        } else {
          promoPriceEl.classList.add("hidden");
          promoPriceEl.classList.remove("block");
          realPriceEl.classList.remove("hidden");
        }
      }, "updatePriceDisplay");
      const updateExtraInformation = /* @__PURE__ */ __name((selectedVariant, allVariants) => {
        var _a, _b;
        const variantWithMetafields = getVariantWithMetafields(selectedVariant, allVariants);
        const promotionRaw = ((_b = (_a = variantWithMetafields == null ? void 0 : variantWithMetafields.metafields) == null ? void 0 : _a.custom) == null ? void 0 : _b.promotion_campaign) || "";
        const promotionData = parsePromotionData(promotionRaw);
        if (promotionData == null ? void 0 : promotionData.campaign_custom_label) {
          extraInfoEl.textContent = promotionData.campaign_custom_label;
          extraInfoEl.classList.remove("hidden");
        } else {
          extraInfoEl.textContent = "";
          extraInfoEl.classList.add("hidden");
        }
      }, "updateExtraInformation");
      const updateAll = /* @__PURE__ */ __name((selectedVariant, allVariants) => {
        updatePriceDisplay(selectedVariant, allVariants);
        updateExtraInformation(selectedVariant, allVariants);
      }, "updateAll");
      document.addEventListener("on:variant:change", (e) => {
        var _a, _b;
        const selectedVariant = (_a = e.detail) == null ? void 0 : _a.variant;
        const allVariants = (_b = e.detail) == null ? void 0 : _b.variants;
        if (!selectedVariant) return;
        updateAll(selectedVariant, allVariants);
      });
    }
    __name(handlePromoPriceAndLabel, "handlePromoPriceAndLabel");
    return {
      init
    };
  }();
  var main_product_default = mainProduct;

  // src/js/features/free_delivery_countdown.js
  var freeDeliveryCountdown = /* @__PURE__ */ function() {
    function createCountdown() {
      let countdownBlocks = document.querySelectorAll(".delivery-countdown-block");
      if (countdownBlocks.length > 0) {
        if (typeof window.deliveryCountdownTargetAmount === "undefined") {
          window.window.deliveryCountdownTargetAmount = 0;
        }
        countdownBlocks.forEach((countdown) => {
          let deliveryCountdownMessage = countdown.querySelector(".delivery-countdown-message");
          let deliveryCountdownSuccess = countdown.querySelector(".delivery-countdown-success");
          let deliveryCountdownCounter = countdown.querySelector(".delivery-countdown-counter");
          let deliveryCountdownAmount = countdown.querySelector(".delivery-countdown-amount");
          const handleCartUpdate = /* @__PURE__ */ __name((event) => {
            let cartAmount = 0;
            let cartAmountExcludingGiftCards = 0;
            fetch("/cart.js").then((response) => response.json()).then((data) => {
              if (data.item_count > 0) {
                let current_line_item = 0;
                while (current_line_item < data.items.length) {
                  let line_item = data.items[current_line_item];
                  let item_title = line_item.title.toLowerCase();
                  if (line_item.gift_card === false && item_title.indexOf("gift card") === -1) {
                    cartAmountExcludingGiftCards += line_item.final_line_price;
                  }
                  current_line_item++;
                }
              }
              cartAmount = cartAmountExcludingGiftCards / 100;
              if (cartAmount == 0) {
                deliveryCountdownCounter.classList.add("hidden");
                deliveryCountdownSuccess.classList.add("hidden");
                deliveryCountdownMessage.classList.remove("hidden");
              } else if (cartAmount >= window.deliveryCountdownTargetAmount) {
                deliveryCountdownCounter.classList.add("hidden");
                deliveryCountdownMessage.classList.add("hidden");
                deliveryCountdownSuccess.classList.remove("hidden");
              } else {
                const remainder = window.deliveryCountdownTargetAmount - cartAmount;
                deliveryCountdownAmount.innerHTML = deliveryCountdownCurrency + remainder.toFixed(2);
                deliveryCountdownMessage.classList.add("hidden");
                deliveryCountdownSuccess.classList.add("hidden");
                deliveryCountdownCounter.classList.remove("hidden");
              }
              return data;
            });
          }, "handleCartUpdate");
          ["on:cart:add", "on:line-item:change"].forEach((eventName) => {
            document.addEventListener(eventName, handleCartUpdate);
          });
        });
      }
    }
    __name(createCountdown, "createCountdown");
    return {
      init: createCountdown
    };
  }();
  var free_delivery_countdown_default = freeDeliveryCountdown;

  // src/js/features/free-gift.js
  var freeGift = /* @__PURE__ */ function() {
    function init() {
      document.addEventListener("rebuy:cart.change", (e) => {
        var _a, _b;
        updateFreeGifts((_b = (_a = e.detail) == null ? void 0 : _a.cart) == null ? void 0 : _b.cart);
      });
    }
    __name(init, "init");
    function fetchCampaignsForCart() {
      return __async(this, null, function* () {
        const response = yield fetch("/?sections=promotion-campaigns");
        if (!response.ok) throw new Error("Failed to load promotion-campaigns section");
        const section_obj = yield response.json();
        const sectionHtml = section_obj["promotion-campaigns"] || "{}";
        const div = document.createElement("div");
        div.innerHTML = sectionHtml;
        const raw = div.querySelector("#shopify-section-promotion-campaigns").innerHTML;
        let parsed = {};
        try {
          parsed = JSON.parse(raw);
        } catch (e) {
          console.error(e);
          parsed = {};
        }
        return parsed.campaigns || {};
      });
    }
    __name(fetchCampaignsForCart, "fetchCampaignsForCart");
    function getParentKeys(cart, hasCampaignByVariant) {
      const parentKeys = /* @__PURE__ */ Object.create(null);
      if (!cart || !Array.isArray(cart.items)) return parentKeys;
      for (const it of cart.items) {
        if (hasCampaignByVariant[it.variant_id]) parentKeys[it.key] = true;
      }
      return parentKeys;
    }
    __name(getParentKeys, "getParentKeys");
    function computeDesiredGiftsForItem(item, subtotal, parentKeys, campaign) {
      if (!campaign) return 0;
      const productQty = Number(item.quantity) || 0;
      const requiredQty = parseInt(campaign.required_quantity);
      const requiredSpend = parseInt(campaign.required_spend);
      if (Number.isFinite(requiredQty) && requiredQty > 0) {
        return Math.floor(productQty / requiredQty);
      }
      if (Number.isFinite(requiredSpend) && requiredSpend > 0) {
        if (parentKeys[item.key] && subtotal >= requiredSpend) {
          return Math.floor(subtotal / requiredSpend);
        }
      }
      return 0;
    }
    __name(computeDesiredGiftsForItem, "computeDesiredGiftsForItem");
    function addItems(itemsToAdd) {
      return __async(this, null, function* () {
        if (!itemsToAdd.length) return;
        yield fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: itemsToAdd
          })
        }).then((response) => response.json()).catch(console.error);
      });
    }
    __name(addItems, "addItems");
    function applyChanges(changesToApply) {
      return __async(this, null, function* () {
        for (const change of changesToApply) {
          yield fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify(change)
          }).then((response) => response.json()).catch(console.error);
        }
      });
    }
    __name(applyChanges, "applyChanges");
    function allocateByCampaign(desiredByParent, campaignByParent, cartItems) {
      const byCampaign = /* @__PURE__ */ new Map();
      for (const item of cartItems) {
        const parentKey = item.key;
        const desired = desiredByParent[parentKey] || 0;
        const campaign = campaignByParent[parentKey];
        if (!campaign) continue;
        const campaignId = String(campaign.id);
        if (!byCampaign.has(campaignId)) {
          byCampaign.set(campaignId, {
            campaign,
            parents: [],
            totalDesired: 0
          });
        }
        const bucket = byCampaign.get(campaignId);
        bucket.parents.push(parentKey);
        bucket.totalDesired += desired;
      }
      const finalDesired = {};
      for (const [campaignId, bucket] of byCampaign.entries()) {
        const maxFree = Number.isFinite(Number(bucket.campaign.max_free)) ? Number(bucket.campaign.max_free) : Infinity;
        let remaining = Math.min(bucket.totalDesired, maxFree);
        for (const parentKey of bucket.parents) {
          const want = desiredByParent[parentKey] || 0;
          const give = Math.min(want, remaining);
          finalDesired[parentKey] = give;
          remaining -= give;
        }
      }
      return finalDesired;
    }
    __name(allocateByCampaign, "allocateByCampaign");
    function indexGiftLinesByCampaign(cart) {
      const giftCountByCampaign = /* @__PURE__ */ Object.create(null);
      const giftLinesByCampaign = /* @__PURE__ */ Object.create(null);
      const giftRemovals = [];
      for (const line of cart.items) {
        const properties = line.properties || {};
        if (!properties._is_free_gift) continue;
        if (!properties._campaign_id) {
          giftRemovals.push({ id: line.key, quantity: 0 });
          continue;
        }
        const campaignId = String(properties._campaign_id);
        const quantity = Number(line.quantity) || 0;
        giftCountByCampaign[campaignId] = (giftCountByCampaign[campaignId] || 0) + quantity;
        (giftLinesByCampaign[campaignId] || (giftLinesByCampaign[campaignId] = [])).push({ key: line.key, quantity });
      }
      return { giftCountByCampaign, giftLinesByCampaign, giftRemovals };
    }
    __name(indexGiftLinesByCampaign, "indexGiftLinesByCampaign");
    function scheduleTrimToCampaign(campaignId, desired, giftCountByCampaign, giftLinesByCampaign, changesToApply) {
      let toRemove = (giftCountByCampaign[campaignId] || 0) - desired;
      if (toRemove <= 0) return;
      const gifts = giftLinesByCampaign[campaignId] || [];
      for (const giftLine of gifts) {
        if (toRemove <= 0) break;
        const take = Math.min(giftLine.quantity, toRemove);
        changesToApply.push({ id: giftLine.key, quantity: giftLine.quantity - take });
        toRemove -= take;
      }
      giftCountByCampaign[campaignId] = desired;
    }
    __name(scheduleTrimToCampaign, "scheduleTrimToCampaign");
    function updateFreeGifts(cart) {
      return __async(this, null, function* () {
        if (!cart || cart.item_count < 1) return false;
        const campaignsByVariantId = yield fetchCampaignsForCart();
        const hasCampaignByVariant = {};
        for (const campaignByVariantId in campaignsByVariantId) {
          if (campaignsByVariantId[campaignByVariantId]) hasCampaignByVariant[Number(campaignByVariantId)] = true;
        }
        const parentKeys = getParentKeys(cart, hasCampaignByVariant);
        const { giftCountByCampaign, giftLinesByCampaign, giftRemovals } = indexGiftLinesByCampaign(cart);
        const subtotal = (Number(cart.total_price) || 0) / 100;
        const desiredByParent = {};
        const campaignByParent = {};
        const campaignInfo = /* @__PURE__ */ new Map();
        for (const item of cart.items) {
          const campaign = campaignsByVariantId[String(item.variant_id)];
          if (!campaign || !campaign.free_gift_id) continue;
          const parentKey = item.key;
          campaignByParent[parentKey] = campaign;
          const desired = Math.max(0, computeDesiredGiftsForItem(item, subtotal, parentKeys, campaign));
          desiredByParent[parentKey] = desired;
          const campaignId = String(campaign.id);
          if (!campaignInfo.has(campaignId)) {
            campaignInfo.set(campaignId, { campaign, free_gift_id: Number(campaign.free_gift_id) });
          }
        }
        const finalDesiredByParent = allocateByCampaign(desiredByParent, campaignByParent, cart.items);
        const desiredByCampaign = /* @__PURE__ */ Object.create(null);
        for (const parentKey in finalDesiredByParent) {
          const campaign = campaignByParent[parentKey];
          if (!campaign) continue;
          const campaignId = String(campaign.id);
          desiredByCampaign[campaignId] = (desiredByCampaign[campaignId] || 0) + Number(finalDesiredByParent[parentKey] || 0);
        }
        const itemsToAdd = [];
        const changesToApply = [...giftRemovals];
        for (const [campaignId, info] of campaignInfo.entries()) {
          const desired = Number(desiredByCampaign[campaignId] || 0);
          const current = Number(giftCountByCampaign[campaignId] || 0);
          if (desired <= 0) {
            scheduleTrimToCampaign(campaignId, 0, giftCountByCampaign, giftLinesByCampaign, changesToApply);
            continue;
          }
          if (current < desired) {
            const delta = desired - current;
            itemsToAdd.push({
              id: info.free_gift_id,
              quantity: delta,
              properties: { _is_free_gift: true, _campaign_id: campaignId }
            });
            giftCountByCampaign[campaignId] = current + delta;
          } else if (current > desired) {
            scheduleTrimToCampaign(campaignId, desired, giftCountByCampaign, giftLinesByCampaign, changesToApply);
          }
        }
        for (const campaignId in giftCountByCampaign) {
          if (!(campaignId in desiredByCampaign) || desiredByCampaign[campaignId] === 0) {
            scheduleTrimToCampaign(campaignId, 0, giftCountByCampaign, giftLinesByCampaign, changesToApply);
          }
        }
        yield addItems(itemsToAdd);
        yield applyChanges(changesToApply);
      });
    }
    __name(updateFreeGifts, "updateFreeGifts");
    return {
      init
    };
  }();
  var free_gift_default = freeGift;

  // src/js/index.js
  (function() {
    document.addEventListener("DOMContentLoaded", function() {
      announcement_default.init();
      free_delivery_countdown_default.init();
      free_gift_default.init();
      if (window.location.href.indexOf("/products/") > -1) {
        main_product_default.init();
      }
    });
  })();
})();
